import { ClientHub, RoleBundleResponse } from "services/clienthub/clienthub.types";
import { RequestInfo } from "store/slice/store.types";
import { Pagination } from "types/globals";
import { getPermissionNameFromRolesList } from "utils";

export type ConvertedClientHub = {
    data: ConvertedClientHubData[];
    meta: Pagination;
    status: RequestInfo;
};

export type ConvertedClientHubUser = {
    id: number;
    term: string;
    value: string;
};

export type ConvertedClientHubData = {
    id: number;
    name: string;
    ldPermission: string;
    pacePermission: string;
    usersCount: number;
    users: ConvertedClientHubUser[];
    crmId: null;
    crmUrl: null;
    createdOn: Date;
};

export const convertClientHubList = (data: ClientHub[], permissions: RoleBundleResponse): ConvertedClientHubData[] => {
    return data.map((clientHub) => {
        const ldPermission = clientHub.roles_ld.length
            ? getPermissionNameFromRolesList(permissions, clientHub.roles_ld, "LD")?.label
            : "";
        const pacePermission = clientHub.roles_pace.length
            ? getPermissionNameFromRolesList(permissions, clientHub.roles_pace, "PACE")?.label
            : "";

        return {
            id: clientHub.id,
            name: clientHub.name,
            ldPermission: ldPermission,
            pacePermission: pacePermission,
            usersCount: clientHub.users_count,
            crmId: clientHub.crm_id,
            crmUrl: clientHub.crm_url,
            createdOn: clientHub.created_utc,
            users: clientHub.users.map((user) => ({
                id: user.id,
                term: user.name,
                value: "",
            })),
        };
    });
};
